import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import {motion} from "framer-motion";
import {useLocation, useNavigate} from "react-router-dom";
import {useProfile} from "../../../contexts/ProfileContext.tsx";
import {cnpjMask} from "../../../regex/cnpjMask";
import {cpfMask} from "../../../regex/cpfMask";

function RenderBodyColunas({
                               colunas,
                               row,
                               handleHover,
                               setTabelaRedux,
                               classeSelecionado,
                               setOpen,
                               isEmbarque,
                               setIsEmbarque,
                               setIsEntrega,
                               setDadosRastrearRedux,
                               breakTd,
                               setOpenRegras,
                               setValues,
                               listaTipos,
                               listaTipos2,
                               setOpenMotivo,
                           }) {
    const {tabelaUsuario, contextoEmbarque} = useProfile();
    const today = new Date();
    const navigate = useNavigate();
    const pathname = useLocation().pathname;

    const getMotionProps = (colIndex) => ({
        whileHover: {backgroundColor: "#f0f8ff"},
        onHoverStart: () => {
            handleHover(colIndex);
        },
        onHoverEnd: () => {
            handleHover(null);
        },
    });

    return (
        <>
            {colunas.map((col, colIndex) => {
                if (col.field === "taxa") {
                    if (row.taxa.includes(",00")) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`taxa--${col.field}-${colIndex}`}
                                className="td-right"
                                style={{color: row.corCliente}}
                            >
                                {row.taxa}
                            </motion.td>
                        );
                    } else {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`taxa--${col.field}-${colIndex}`}
                                className="td-right"
                                style={{color: row.corCliente}}
                            >
                                {row.taxa},00
                            </motion.td>
                        );
                    }
                }
                if (col.objetoTipoDocumento === "true") {
                    if (row.tipoDocumentoEnum) {
                        if (row.tipoDocumentoEnum === 1) {
                            return (
                                <motion.td
                                    {...getMotionProps(colIndex)}
                                    key={`tipoDocumento--${col.field}-${colIndex}`}
                                    style={{color: row.corCliente}}
                                >
                                    Múltiplo
                                </motion.td>
                            );
                        }
                        if (row.tipoDocumentoEnum === 2) {
                            return (
                                <motion.td
                                    {...getMotionProps(colIndex)}
                                    key={`tipoDocumento--${col.field}-${colIndex}`}
                                    style={{color: row.corCliente}}
                                >
                                    Simples
                                </motion.td>
                            );
                        }
                    }
                }
                if (col.objetoTipoContato === "true") {
                    if (row.tipoContatoEnum) {
                        if (row.tipoContatoEnum === 1) {
                            return (
                                <motion.td
                                    {...getMotionProps(colIndex)}
                                    key={`tipoContato--${col.field}-${colIndex}`}
                                    style={{color: row.corCliente}}
                                >
                                    Telefone
                                </motion.td>
                            );
                        }
                        if (row.tipoContatoEnum === 2) {
                            return (
                                <motion.td
                                    {...getMotionProps(colIndex)}
                                    key={`tipoContato--${col.field}-${colIndex}`}
                                    style={{color: row.corCliente}}
                                >
                                    Email
                                </motion.td>
                            );
                        }
                    }
                }
                if (col.field === "elegivelBrf") {
                    if (row.elegivelBrf) {
                        if (row.elegivelBrf === 0) {
                            return (
                                <motion.td
                                    {...getMotionProps(colIndex)}
                                    key={`elegivelBrf--${col.field}-${colIndex}`}
                                    style={{color: row.corCliente}}
                                />
                            );
                        }
                        if (row.elegivelBrf === 1) {
                            return (
                                <motion.td
                                    {...getMotionProps(colIndex)}
                                    key={`elegivelBrf--${col.field}-${colIndex}`}
                                    style={{color: row.corCliente}}
                                >
                                    BRF A
                                </motion.td>
                            );
                        }
                        if (row.elegivelBrf === 2) {
                            return (
                                <motion.td
                                    {...getMotionProps(colIndex)}
                                    key={`elegivelBrf--${col.field}-${colIndex}`}
                                    style={{color: row.corCliente}}
                                >
                                    BRF B
                                </motion.td>
                            );
                        }
                        if (row.elegivelBrf === 3) {
                            return (
                                <motion.td
                                    {...getMotionProps(colIndex)}
                                    key={`elegivelBrf--${col.field}-${colIndex}`}
                                    style={{color: row.corCliente}}
                                >
                                    BRF C
                                </motion.td>
                            );
                        }
                        if (row.elegivelBrf === 4) {
                            return (
                                <motion.td
                                    {...getMotionProps(colIndex)}
                                    key={`elegivelBrf--${col.field}-${colIndex}`}
                                    style={{color: row.corCliente}}
                                >
                                    BRF Spot
                                </motion.td>
                            );
                        }
                        if (row.elegivelBrf === 5) {
                            return (
                                <motion.td
                                    {...getMotionProps(colIndex)}
                                    key={`elegivelBrf--${col.field}-${colIndex}`}
                                    style={{color: row.corCliente}}
                                >
                                    BRF OTM
                                </motion.td>
                            );
                        }
                        if (row.elegivelBrf === 6) {
                            return (
                                <motion.td
                                    {...getMotionProps(colIndex)}
                                    key={`elegivelBrf--${col.field}-${colIndex}`}
                                    style={{color: row.corCliente}}
                                >
                                    BRF Inelegível
                                </motion.td>
                            );
                        }
                    }
                }
                if (col.field === "proprietario") {
                    return (
                        <motion.td
                            {...getMotionProps(colIndex)}
                            style={{color: row.corCliente}}
                        >
                            {typeof row.proprietario === "object" && !!row.proprietario
                                ? row.proprietario.nome
                                : row.proprietario}
                        </motion.td>
                    );
                }
                if (col.field === "veiculoMotorista") {
                    if (row.veiculoMotorista) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`veiculoMotorista--${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                {row.veiculoMotorista.nome}
                            </motion.td>
                        );
                    }
                }
                if (col.field === "cotacaoCarroceria") {
                    if (row.cotacaoCarroceria && row.cotacaoCarroceria.length > 0) {
                        const carroceriasNomes = row.cotacaoCarroceria
                            .map((item) => item.carroceria.nome)
                            .join(", ");
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`cotacaoCarroceria--${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                {carroceriasNomes}
                            </motion.td>
                        );
                    }
                }
                if (col.field === "usuarioResponsavel") {
                    if (row.usuarioResponsavel?.usuario) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`usuarioResponsavel--${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                {row.usuarioResponsavel.usuario}
                            </motion.td>
                        );
                    } else {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`usuarioResponsavel--${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                {row.usuarioResponsavel}
                            </motion.td>
                        );
                    }
                }
                if (col.field === "tipoVeiculo") {
                    if (col.objetoTipoVeiculo === "true") {
                        if (row.tipoVeiculo) {
                            return (
                                <motion.td
                                    {...getMotionProps(colIndex)}
                                    key={`tipoVeiculo--${col.field}-${colIndex}`}
                                    style={{color: row.corCliente}}
                                >
                                    {row.tipoVeiculo.nome}
                                </motion.td>
                            );
                        }
                    } else {
                        if (row.tipoVeiculo) {
                            const tipoVeiculoSelecionado = listaTipos.find(
                                (opcao) => opcao.valor === row.tipoVeiculo
                            );
                            if (tipoVeiculoSelecionado) {
                                return (
                                    <motion.td
                                        {...getMotionProps(colIndex)}
                                        key={`tipoVeiculo--${col.field}-${colIndex}`}
                                        style={{color: row.corCliente}}
                                    >
                                        {tipoVeiculoSelecionado.opcao}
                                    </motion.td>
                                );
                            }
                        }
                    }
                }
                if (col.objetoDocumentacao1 === "true") {
                    if (
                        row.veiculo?.caminhao !== undefined &&
                        row.veiculo?.caminhao !== null
                    ) {
                        if (
                            (row.dataValidadeAntt &&
                                new Date(row.dataValidadeAntt) < today) ||
                            (row.dataValidadeCnhMotorista &&
                                new Date(row.dataValidadeCnhMotorista) < today) ||
                            (row.dataValidadeComprovanteResidencia &&
                                new Date(row.dataValidadeComprovanteResidencia) < today) ||
                            (row.dataValidadeCrlv &&
                                new Date(row.dataValidadeCrlv) < today) ||
                            (row.dataValidadeFotoVeiculo &&
                                new Date(row.dataValidadeFotoVeiculo) < today)
                        ) {
                            return (
                                <motion.td
                                    {...getMotionProps(colIndex)}
                                    key={`caminhaoPlaca--${col.field}-${colIndex}`}
                                    className="data-piscando-1"
                                    style={{color: row.corCliente}}
                                >
                                    {row.veiculo?.caminhao?.placa}
                                </motion.td>
                            );
                        } else {
                            return (
                                <motion.td
                                    {...getMotionProps(colIndex)}
                                    key={`caminhaoPlaca--${col.field}-${colIndex}`}
                                    style={{color: row.corCliente}}
                                >
                                    {row.veiculo?.caminhao?.placa}
                                </motion.td>
                            );
                        }
                    }
                }
                if (col.objetoDocumentacao2 === "true") {
                    if (!!row.veiculo?.proprietarioVeiculo) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`proprietarioVeiculo--${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                {row.veiculo?.proprietarioVeiculo?.nome}
                            </motion.td>
                        );
                    }
                }
                if (col.objetoDocumentacao3 === "true") {
                    if (
                        row.veiculo?.veiculoMotorista !== undefined &&
                        row.veiculo?.veiculoMotorista !== null
                    ) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`veiculoMotorista--${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                {row.veiculo?.veiculoMotorista?.nome}
                            </motion.td>
                        );
                    }
                }
                if (col.objetoTipoCarroceria === "true") {
                    if (row.tipoCarroceria) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`tipoCarroceria--${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                {row.tipoCarroceria?.nome}
                            </motion.td>
                        );
                    }
                }
                if (col.objetoCidadeEstado === "true") {
                    if (row.cidadeEstado !== undefined && row.cidadeEstado !== null) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`cidadeEstado--${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                {row.cidadeEstado.abreviacao
                                    ? row.cidadeEstado.abreviacao
                                    : row.cidadeEstado.cidade}{" "}
                                - {row.cidadeEstado.estado}
                            </motion.td>
                        );
                    }
                }
                if (col.objetoTipoVeiculo === "true") {
                    if (row.tipoVeiculoConjuntos) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`tipoVeiculoConjuntos--${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                {row.tipoVeiculoConjuntos?.nome}
                            </motion.td>
                        );
                    }
                }
                if (col.objetoSegmentoCliente === "true") {
                    if (row.segmentoCliente) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`segmentoCliente--${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                {row.segmentoCliente?.nome}
                            </motion.td>
                        );
                    }
                }
                if (col.objetoMotivo === "true") {
                    if (row.motivoCotacao !== undefined && row.motivoCotacao !== null) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`motivoCotacao--${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                {row.motivoCotacao.motivo}
                            </motion.td>
                        );
                    }
                }
                if (col.objetoMotivo === "true") {
                    if (
                        row.motivoEstadiaId !== undefined &&
                        row.motivoEstadiaId !== null
                    ) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`motivoEstadia--${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                {row.motivoEstadia.motivo}
                            </motion.td>
                        );
                    }
                }
                if (col.field === "cteComplementar") {
                    return (
                        <motion.td
                            {...getMotionProps(colIndex)}
                            key={`cteComplementar--${col.field}-${colIndex}`}
                            style={{color: row.corCliente}}
                        >
                            {row.cteComplementar}
                        </motion.td>
                    );
                }
                if (col.field === "tipoEstadia") {
                    if (row.tipoEstadia === 1) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`tipoEstadia--${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                Diária de descarga
                            </motion.td>
                        );
                    }
                    if (row.tipoEstadia === 2) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`tipoEstadia--${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                Taxa de descarga
                            </motion.td>
                        );
                    }
                    if (row.tipoEstadia === 3) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`tipoEstadia--${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                Taxa devolução
                            </motion.td>
                        );
                    }
                }
                if (col.objetoStatus === "true") {
                    if (row.statusDiariaId !== undefined && row.statusDiariaId !== null) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`statusDiaria--${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                {row.statusDiaria.status}
                            </motion.td>
                        );
                    }
                }
                if (col.objetoTipoVeiculo === "true") {
                    if (row.tipoVeiculoId) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`tipoVeiculo--${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                {row.tipoVeiculo?.nome}
                            </motion.td>
                        );
                    }
                }
                if (col.objetoEmb === "true") {
                    if (
                        col.field === "veiculoEmbarque" &&
                        row.embarque.veiculoEmbarque !== null
                    ) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`veiculoEmbarque--${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                {row.embarque[col.field].caminhao.placa}
                            </motion.td>
                        );
                    }
                    if (
                        col.field === "dataHoraChegadaEmbarque" ||
                        col.field === "dataHoraEmbarcado" ||
                        col.field === "dataHoraEntregue"
                    ) {
                        if (
                            row[col.field] === "2000-01-01T00:00:00" ||
                            row[col.field] === null
                        ) {
                            return (
                                <motion.td
                                    {...getMotionProps(colIndex)}
                                    key={`dataHoraChegadaEmbarque--${col.field}-${colIndex}`}
                                    style={{color: row.corCliente}}
                                />
                            );
                        } else {
                            return (
                                <motion.td
                                    {...getMotionProps(colIndex)}
                                    key={`dataHoraChegadaEmbarque--${col.field}-${colIndex}`}
                                    style={{color: row.corCliente}}
                                >
                                    {new Date(row.embarque[col.field]).toLocaleDateString(
                                        "pt-BR",
                                        {
                                            month: "numeric",
                                            day: "numeric",
                                            hour: "numeric",
                                            minute: "numeric",
                                        }
                                    )}
                                </motion.td>
                            );
                        }
                    }
                    if (row.embarque[col.field]) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`veiculoEmbarque--${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                {row.embarque[col.field]}
                            </motion.td>
                        );
                    }
                }
                if (col.objetoUnidadeEmbarqueNome === "true") {
                    if (row.unidadeEmbarque) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`unidadeEmbarque--${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                {row.unidadeEmbarque?.nome}
                            </motion.td>
                        );
                    }
                }
                if (col.field === "fabricanteRastreamento") {
                    if (row.fabricanteRastreamento) {
                        const fabricanteRastreamentoSelecionado = listaTipos2?.find(
                            (opcao) => opcao.valor === row.fabricanteRastreamento
                        );
                        if (fabricanteRastreamentoSelecionado) {
                            return (
                                <motion.td
                                    {...getMotionProps(colIndex)}
                                    key={`fabricanteRastreamento--${col.field}-${colIndex}`}
                                    style={{color: row.corCliente}}
                                >
                                    {fabricanteRastreamentoSelecionado.opcao}
                                </motion.td>
                            );
                        }
                    }
                }
                if (
                    col.field === "dataHoraAcontecido" ||
                    col.field === "dataHoraChegada" ||
                    col.field === "dataHoraPrevisao" ||
                    col.field === "dataAtualizacaoLocalizacao"
                ) {
                    if (
                        row[col.field] === "2000-01-01T00:00:00" ||
                        row[col.field] === null
                    ) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`dataHora--${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            />
                        );
                    } else {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`dataHora--${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                {new Date(row[col.field]).toLocaleDateString("pt-BR", {
                                    month: "numeric",
                                    day: "numeric",
                                    hour: "numeric",
                                    minute: "numeric",
                                })}
                            </motion.td>
                        );
                    }
                }
                if (col.field === "onTime") {
                    if (row.onTime === true) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`onTime--${col.field}-${colIndex}`}
                                style={{color: "#48B43B"}}
                            >
                                On Time
                            </motion.td>
                        );
                    } else if (row.onTime === null) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`onTime--${col.field}-${colIndex}`}
                            >
                                Aguardando
                            </motion.td>
                        );
                    } else {
                        if (row.motivoOnTime !== null) {
                            return (
                                <motion.td
                                    {...getMotionProps(colIndex)}
                                    key={`onTime--${col.field}-${colIndex}`}
                                    style={{color: "#FF0000"}}
                                >
                                    Ñ On Time
                                </motion.td>
                            );
                        } else {
                            return (
                                <motion.td
                                    {...getMotionProps(colIndex)}
                                    key={`onTime--${col.field}-${colIndex}`}
                                    style={{color: "#FF0000"}}
                                >
                                    Ñ On Time
                                </motion.td>
                            );
                        }
                    }
                }
                if (col.field === "motivoOnTime") {
                    if (row.motivoOnTime !== undefined || row.motivoOnTime !== null) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`motivoOnTime--${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                <span className="">{row.motivoOnTime?.motivo}</span>
                            </motion.td>
                        );
                    } else {
                        if (row.onTime === false) {
                            return (
                                <motion.td
                                    {...getMotionProps(colIndex)}
                                    key={`motivoOnTime--${col.field}-${colIndex}`}
                                    style={{color: row.corCliente}}
                                >
									<span
                                        className="endereco"
                                        style={{color: "#5353ef"}}
                                        onClick={() => {
                                            const lista = [];
                                            lista.push(row.embarque);
                                            setTabelaRedux({
                                                colunaSelecionada: row[classeSelecionado],
                                                usuarioAlteracao: row.usuario,
                                                dataAlteracao: row.data,
                                                row: lista,
                                            });
                                            setOpen(true);
                                            if (isEmbarque === true) {
                                                setIsEmbarque(true);
                                                setIsEntrega(false);
                                            } else if (setIsEntrega) {
                                                setIsEmbarque(false);
                                                setIsEntrega(true);
                                            }
                                        }}
                                    >
										Adicionar
									</span>
                                </motion.td>
                            );
                        }
                    }
                }
                if (col.objetoCliente === "true") {
                    if (row.cliente) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`cliente--${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                {row.cliente?.nomeFantasia}
                            </motion.td>
                        );
                    }
                }
                if (col.objetoGrupoCarga === "true") {
                    if (row.grupoCarga) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`grupoCarga--${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                {row.grupoCarga?.nomeGrupo}
                            </motion.td>
                        );
                    }
                }
                if (col.objetoMotorista === "true") {
                    if (row.motorista) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`motorista--${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                {row.motorista?.nome}
                            </motion.td>
                        );
                    }
                }
                if (col.objetoProprietario === "true") {
                    if (row.proprietario) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`proprietario--${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                {row.proprietario?.nome}
                            </motion.td>
                        );
                    }
                }
                if (col.objetoRota === "true") {
                    if (row.rota?.nome) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`rota--${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                {row.rota.nome}
                            </motion.td>
                        );
                    } else {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`nomeRota--${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                {row.nomeRota}
                            </motion.td>
                        );
                    }
                }
                if (col.objetoGrupoPrecificacao === "true") {
                    if (row.grupoPrecificacao) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`grupoPrecificacao--${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                {row.grupoPrecificacao.nome}
                            </motion.td>
                        );
                    }
                }
                if (col.objetoUsuarios === "true") {
                    if (row.usuariosClientes) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`usuariosClientes--${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                {row.usuariosClientes.usuario}
                            </motion.td>
                        );
                    }
                }
                if (col.field === "telefone") {
                    return (
                        <motion.td
                            {...getMotionProps(colIndex)}
                            key={`telefone--${col.field}-${colIndex}`}
                            style={{color: row.corCliente}}
                        >
                            {row.telefone}
                        </motion.td>
                    );
                }
                if (
                    col.field === "nomeFantasia" ||
                    col.field === "razaoSocial" ||
                    col.field === "projetado" ||
                    col.field === "cte" ||
                    col.field === "numeroRastreador" ||
                    col.field === "pedido"
                ) {
                    return (
                        <motion.td
                            {...getMotionProps(colIndex)}
                            key={`nomeFantasia-${row.id}-${col.field}-${colIndex}`}
                            style={{color: row.corCliente}}
                        >
                            {row[col.field]}
                        </motion.td>
                    );
                }
                if (col.field === "km") {
                    return (
                        <motion.td
                            {...getMotionProps(colIndex)}
                            key={`km--${col.field}-${colIndex}`}
                            className="td-right"
                            style={{color: row.corCliente}}
                        >
                            {row[col.field]}
                        </motion.td>
                    );
                }
                if (col.field === "tempoEsperando") {
                    return (
                        <motion.td
                            {...getMotionProps(colIndex)}
                            key={`tempoEsperando--${col.field}-${colIndex}`}
                            className="td-right"
                            style={{color: row.corCliente}}
                        >
                            {row[col.field].replace(/:00$/, "")}
                        </motion.td>
                    );
                }
                if (col.objetoGrupoCliente === "true") {
                    if (row.grupoCliente) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`grupoCliente--${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                {row.grupoCliente.nome}
                            </motion.td>
                        );
                    }
                }
                if (col.objetoTipoOcorrencia === "true") {
                    if (row.tipoOcorrencia) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`tipoOcorrencia--${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                {row.tipoOcorrencia.nome}
                            </motion.td>
                        );
                    }
                }
                if (col.objetoEndereco === "true") {
                    if (row.endereco) {
                        const isRotaEmpresaSub = pathname.includes("/empresa-sub");
                        const isRotaMotorista = pathname.includes("/motorista");
                        const classNameEndereco = isRotaEmpresaSub || isRotaMotorista ? "" : "endereco";
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`endereco--${col.field}-${colIndex}`}
                                className={classNameEndereco}
                                onClick={(e) => {
                                    if (isRotaEmpresaSub || isRotaMotorista) {
                                        return;
                                    }
                                    setDadosRastrearRedux((current) => ({
                                        ...current,
                                        endereco: row.endereco,
                                    }));
                                    navigate("/rastrear");
                                }}
                            >
                                {row.endereco?.rua +
                                    ", " +
                                    row.endereco?.numero +
                                    ", " +
                                    row.endereco?.bairro +
                                    " - " +
                                    row.endereco?.cidade}
                            </motion.td>
                        );
                    }
                }
                if (col.field === "tempoDiariaMinutos") {
                    if (row.tempoDiariaMinutos) {
                        const minutos = row.tempoDiariaMinutos;

                        let displayValue;
                        if (minutos >= 525600) {
                            displayValue = `${(minutos / (60 * 24 * 365)).toFixed(0)} anos`;
                        } else if (minutos >= 1440) {
                            displayValue = `${(minutos / (60 * 24)).toFixed(0)} dias`;
                        } else if (minutos >= 60) {
                            displayValue = `${(minutos / 60).toFixed(0)} horas`;
                        } else {
                            displayValue = `${minutos} minutos`;
                        }

                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`tempoDiariaMinutos--${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                {displayValue}
                            </motion.td>
                        );
                    }
                }
                if (col.field === "regimeTributario") {
                    if (row.regimeTributario === 1) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`regimeTributario--${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                Simples nacional
                            </motion.td>
                        );
                    }
                    if (row.regimeTributario === 2) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`regimeTributario--${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                Lucro presumido
                            </motion.td>
                        );
                    }
                    if (row.regimeTributario === 3) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`regimeTributario--${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                Lucro real
                            </motion.td>
                        );
                    }
                }
                if (
                    col.field === "ano" ||
                    col.field === "renavam" ||
                    col.field === "modelo" ||
                    col.field === "numeroDocumento" ||
                    col.field === "numeroEixos" ||
                    col.field === "pedido" ||
                    col.field === "cuponsPorViagem" ||
                    col.field === "numerosKmPorCupom" ||
                    col.field === "nome" ||
                    col.field === "tempoDiariaMinutos"
                ) {
                    return (
                        <motion.td
                            {...getMotionProps(colIndex)}
                            key={`campoGenerico-${row[col.field]}-${row.id}-${colIndex}`}
                            style={{color: row.corCliente}}
                        >
                            {row[col.field]}
                        </motion.td>
                    );
                }
                if (col.objetoRastreamento === "true") {
                    return (
                        <motion.td
                            {...getMotionProps(colIndex)}
                            key={`objetoRastreamento--${col.field}-${colIndex}`}
                            style={{color: row.corCliente}}
                        >
                            {row.tipoRastreamento.nome}
                        </motion.td>
                    );
                }
                if (col.objetoVeiculo === "true") {
                    if (row.caminhao) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`caminhao--${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                {row.caminhao.placa}
                            </motion.td>
                        );
                    }
                    if (row.carreta) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`carreta--${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                {row.carreta.placa}
                            </motion.td>
                        );
                    }
                }
                if (col.field === "ip") {
                    return (
                        <motion.td
                            {...getMotionProps(colIndex)}
                            key={`ip--${col.field}-${colIndex}`}
                        >
                            {row.ip}
                        </motion.td>
                    );
                }
                if (col.field === "cnpj") {
                    if (row.cnpj.length === 11) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`cnpj--${col.field}-${colIndex}`}
                            >
                                {cpfMask(row.cnpj)}
                            </motion.td>
                        );
                    } else if (row.cnpj.length > 11) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`cnpj--${col.field}-${colIndex}`}
                            >
                                {cnpjMask(row.cnpj)}
                            </motion.td>
                        );
                    }
                }
                if (col.field === "tipoProprietario") {
                    if (row.tipoProprietario === 2) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`tipoProprietario--${col.field}-${colIndex}`}
                            >
                                ETC
                            </motion.td>
                        );
                    } else if (row.tipoProprietario === 1) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`tipoProprietario--${col.field}-${colIndex}`}
                            >
                                ETC - Equiparado
                            </motion.td>
                        );
                    }
                }
                if (col.field === "descricao") {
                    if (contextoEmbarque === "templateEmbarque") {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`descricao--${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                {row.descricao}
                            </motion.td>
                        );
                    }
                }
                if (col.objetoUnidadeEmbarque === "true") {
                    return (
                        <motion.td
                            {...getMotionProps(colIndex)}
                            key={`objetoUnidadeEmbarque--${col.field}-${colIndex}`}
                            style={{color: row.corCliente}}
                        >
                            {row.cidadeEstado.cidade}
                        </motion.td>
                    );
                }
                if (col.tipo === "number") {
                    return (
                        <motion.td
                            {...getMotionProps(colIndex)}
                            key={`number--${col.field}-${colIndex}`}
                            style={{color: row.corCliente}}
                            className="td-right"
                        >
                            {row[col.field]}
                        </motion.td>
                    );
                }
                if (
                    col.field === "notificarAutomatico" ||
                    col.field === "diFreteFiscal" ||
                    col.field === "diPedagio" ||
                    col.field === "diClassificacao" ||
                    col.field === "bloqueado" ||
                    col.field === "apenasCpf" ||
                    col.field === "motoristas" ||
                    col.field === "proprietarios" ||
                    col.field === "sorteados" ||
                    col.field === "encerrado" ||
                    col.field === "diariaEmbarque" ||
                    col.field === "diariaEntrega" ||
                    col.field === "somaDiarias" ||
                    col.field === "notificarACadaKm" ||
                    col.field === "ativoDiaria"
                ) {
                    if (row[col.field] === true) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`boolean-${row.id}-${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                Sim
                            </motion.td>
                        );
                    } else {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`boolean-${row.id}-${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                Não
                            </motion.td>
                        );
                    }
                }
                if (col.field === "sabadoDiaUtil") {
                    if (row[col.field] === null) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`sabadoDiaUtil-${row.id}-${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                Não Conta
                            </motion.td>
                        );
                    } else if (row[col.field] === true) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`sabadoDiaUtil-${row.id}-${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                Dia Inteiro
                            </motion.td>
                        );
                    } else {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`sabadoDiaUtil-${row.id}-${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                Meio Dia
                            </motion.td>
                        );
                    }
                }
                if (col.field === "foiCarregado") {
                    if (row[col.field] === true) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`foiCarregado-${row.id}-${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                Sim
                            </motion.td>
                        );
                    } else if (row[col.field] === false) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`foiCarregado-${row.id}-${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                Não
                            </motion.td>
                        );
                    } else if (row[col.field] === null) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`foiCarregado-${row.id}-${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                Aguardando
                            </motion.td>
                        );
                    }
                }
                if (col.field === "notificarACadaData") {
                    return (
                        <motion.td
                            {...getMotionProps(colIndex)}
                            key={`notificarACadaData-${row.id}-${col.field}-${colIndex}`}
                            style={{color: row.corCliente}}
                        >
                            {row.notificarACadaData}
                        </motion.td>
                    );
                }
                if (col.field === "tipoCheck") {
                    return (
                        <motion.td
                            {...getMotionProps(colIndex)}
                            key={`tipoCheck-${row.id}-${col.field}-${colIndex}`}
                            style={{color: row.corCliente}}
                        >
                            {row.tipoCheck.nome}
                        </motion.td>
                    );
                }
                if (col.field === "dataCheckagem") {
                    return (
                        <motion.td
                            {...getMotionProps(colIndex)}
                            key={`dataCheckagem-${row.id}-${col.field}-${colIndex}`}
                            style={{color: row.corCliente}}
                            className="td-center"
                        >
                            {new Date(row.dataCheckagem).toLocaleDateString("pt-BR", {
                                year: "numeric",
                                month: "numeric",
                                day: "numeric",
                            })}
                        </motion.td>
                    );
                }
                if (
                    col.field === "fimBusca" ||
                    col.field === "inicioBusca" ||
                    col.field === "dataSorteio"
                ) {
                    return (
                        <motion.td
                            {...getMotionProps(colIndex)}
                            key={`dataCheckagem-${row.id}-${col.field}-${colIndex}`}
                            style={{color: row.corCliente}}
                        >
                            {new Date(row[col.field]).toLocaleDateString("pt-BR", {
                                month: "numeric",
                                day: "numeric",
                                hour: "numeric",
                                minute: "numeric",
                            })}
                        </motion.td>
                    );
                }

                if (col.field === "dataCotacao") {
                    return (
                        <motion.td
                            {...getMotionProps(colIndex)}
                            key={`dataCotacao-${row.id}-${col.field}-${colIndex}`}
                            style={{color: row.corCliente}}
                            className="td-center"
                        >
                            {new Date(row.dataCotacao).toLocaleDateString("pt-BR", {
                                year: "numeric",
                                month: "numeric",
                                day: "numeric",
                            })}
                        </motion.td>
                    );
                }
                if (col.field === "proximaRevisaoData") {
                    if (row.proximaRevisaoData === null) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`proximaRevisaoData-${row.id}-${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            />
                        );
                    } else {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`proximaRevisaoData-${row.id}-${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                                className="td-center"
                            >
                                {new Date(row.proximaRevisaoData).toLocaleDateString("pt-BR", {
                                    year: "numeric",
                                    month: "numeric",
                                    day: "numeric",
                                })}
                            </motion.td>
                        );
                    }
                }
                if (col.field === "frota") {
                    if (row.frota === true) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`frota-${row.id}-${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                Sim
                            </motion.td>
                        );
                    } else {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`frota-${row.id}-${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                Não
                            </motion.td>
                        );
                    }
                }
                if (col.field === "agregado") {
                    if (row.agregado === true) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`agregado-${row.id}-${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                Sim
                            </motion.td>
                        );
                    } else {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`agregado-${row.id}-${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                Não
                            </motion.td>
                        );
                    }
                }
                if (col.field === "telemetria") {
                    if (row.telemetria === true) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`telemetria-${row.id}-${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                Sim
                            </motion.td>
                        );
                    } else {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`telemetria-${row.id}-${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                Não
                            </motion.td>
                        );
                    }
                }
                if (col.field === "previsaoEmbarque") {
                    if (
                        row.previsaoEmbarque === "2000-01-01T00:00:00" ||
                        row.previsaoEmbarque === null
                    ) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`previsaoEmbarque-${row.id}-${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            />
                        );
                    } else {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`previsaoEmbarque-${row.id}-${col.field}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                {new Date(row.previsaoEmbarque).toLocaleDateString("pt-BR", {
                                    month: "numeric",
                                    day: "numeric",
                                    hour: "numeric",
                                    minute: "numeric",
                                })}
                            </motion.td>
                        );
                    }
                }
                if (col.field === "permissoes") {
                    return (
                        <motion.td
                            {...getMotionProps(colIndex)}
                            key={`permissoes-${row.id}-${col.field}-${colIndex}`}
                            style={{color: row.corCliente}}
                        >{`${row.regras},`}</motion.td>
                    );
                }
                if (col.field === "nascimento") {
                    return (
                        <motion.td
                            {...getMotionProps(colIndex)}
                            key={`nascimento-${row.id}-${col.field}-${colIndex}`}
                            style={{color: row.corCliente}}
                        >
                            {new Date(row.nascimento).toLocaleDateString("pt-BR", {
                                year: "numeric",
                                month: "numeric",
                                day: "numeric",
                            })}
                        </motion.td>
                    );
                }
                if (col.field === "ultimoLogin" && row.ultimoLogin !== null) {
                    return (
                        <motion.td
                            {...getMotionProps(colIndex)}
                            key={`ultimoLogin-${row.id}-${col.field}-${colIndex}`}
                            style={{color: row.corCliente}}
                        >
                            {new Date(row.ultimoLogin).toLocaleDateString("pt-BR", {
                                year: "numeric",
                                month: "numeric",
                                day: "numeric",
                                hour: "numeric",
                                minute: "numeric",
                            })}
                        </motion.td>
                    );
                }
                if (col.field === "ultimoLogout" && row.ultimoLogout !== null) {
                    return (
                        <motion.td
                            {...getMotionProps(colIndex)}
                            key={`ultimoLogout-${row.id}-${col.field}-${colIndex}`}
                            style={{color: row.corCliente}}
                        >
                            {new Date(row.ultimoLogout).toLocaleDateString("pt-BR", {
                                year: "numeric",
                                month: "numeric",
                                day: "numeric",
                                hour: "numeric",
                                minute: "numeric",
                            })}
                        </motion.td>
                    );
                }
                if (col.field === "data") {
                    return (
                        <motion.td
                            {...getMotionProps(colIndex)}
                            key={`data-${row.id}-${col.field}-${colIndex}`}
                            style={{color: row.corCliente}}
                        >
                            {new Date(row.data).toLocaleDateString("pt-BR", {
                                year: "numeric",
                                month: "numeric",
                                day: "numeric",
                            })}
                        </motion.td>
                    );
                }
                if (col.field === "mensagem") {
                    return (
                        <motion.td
                            {...getMotionProps(colIndex)}
                            key={`mensagem-${row.id}-${col.field}-${colIndex}`}
                            style={{color: row.corCliente}}
                            className={breakTd ? breakTd : ""}
                        >
                            {row.mensagem}
                        </motion.td>
                    );
                }
                if (col.objetoUnidadeEmbarque === "true") {
                    return (
                        <motion.td
                            {...getMotionProps(colIndex)}
                            key={`cidade-${row.id}-${col.field}-${colIndex}`}
                            style={{color: row.corCliente}}
                        >
                            {row.cidadeEstado.cidade}
                        </motion.td>
                    );
                }
                if (col.objetoUnidadeEmbarque === "true") {
                    return (
                        <motion.td
                            {...getMotionProps(colIndex)}
                            key={`cidade-${row.id}-${col.field}-${colIndex}`}
                            style={{color: row.corCliente}}
                        >
                            {row.cidadeEstado.cidade}
                        </motion.td>
                    );
                }
                if (col.field === "aceitar") {
                    return (
                        <motion.td
                            {...getMotionProps(colIndex)}
                            key={`aceitar-${row.id}-${col.field}-${colIndex}`}
                            style={{color: row.corCliente}}
                            className="td-center"
                        >
                            <CheckIcon
                                className="icon-filtro"
                                onClick={(e) => {
                                    setOpenRegras && setOpenRegras(true);
                                    setValues &&
                                    setValues({
                                        colunas: JSON.stringify(tabelaUsuario).replace(/"/g, `'`),
                                        usuarioId: row.usuarioId,
                                        regras: [],
                                    });
                                }}
                            />
                        </motion.td>
                    );
                }
                if (col.field === "recusar") {
                    return (
                        <motion.td
                            {...getMotionProps(colIndex)}
                            key={`recusar-${row.id}-${col.field}-${colIndex}`}
                            style={{color: row.corCliente}}
                            className="td-center"
                        >
                            <ClearIcon
                                className="icon-filtro"
                                onClick={(e) => {
                                    setOpenMotivo(true);
                                }}
                            />
                        </motion.td>
                    );
                } else {
                    if (isNaN(parseFloat(row[col.field]))) {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`campo-${row[col.field]}-${row.id}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                {row[col.field]}
                            </motion.td>
                        );
                    } else {
                        return (
                            <motion.td
                                {...getMotionProps(colIndex)}
                                key={`campo-${row[col.field]}-${row.id}-${colIndex}`}
                                style={{color: row.corCliente}}
                            >
                                {parseFloat(row[col.field]).toLocaleString("pt-BR", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                })}
                            </motion.td>
                        );
                    }
                }
            })}
        </>
    );
}

export default RenderBodyColunas;
